module.exports = __webpack_public_path__ + "static/img/257_TO8_2319_og.28e17ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/257_TO8_2319_og.jpg
// module id = 7FgG
// module chunks = 0